import * as d3 from "d3";
import React, { useRef,useState,useEffect } from "react";
import { useDispatch } from "react-redux";
import { setListingData } from "../../store/listing/listingSlice";
import { other } from "../../common/labelConstants";

const _props = {
  labels: [],
  datasets: [],
  totalDatasets: 0,
  graphConfig: {},
  clickFilter: () => {},
  dataListTemplate: "",
  setReset: () => {},
};

export const Treemap = (props = _props) => {
  const dispatch = useDispatch()
  const tooltipRef = useRef(null);
  const svgContainer = useRef(null);
  const [selectedNode, setSelectedNode] = useState(null)
  const [height,setHeight] = useState()
  const [width,setWidth] = useState()

  const labels = props.labels.map(
    (item) => (typeof item) === 'object' ? other:item);
  
  const data = props.datasets
  .map((el, index) => {
    return { name: labels[index], value: el };
  }).sort((a, b) => b.value - a.value);
  

  const colors = props.graphConfig.colorPalette;

  const root = d3
    .hierarchy({ children: data })
    .sum((d) => d.value)
    .sort((a, b) => b.value - a.value);

    const getSvgContainerSize = () => {
      const newWidth = svgContainer.current.parentNode.clientWidth ;
      setWidth(newWidth);
  
      // const newHeight = svgContainer.current.clientHeight;
      setHeight(newWidth / 2.22134387352);
    };
  
    useEffect(() => {
      // detect 'width' and 'height' on render
      getSvgContainerSize();
      // listen for resize changes, and detect dimensions again when they change
      window.addEventListener("resize", getSvgContainerSize);
      // cleanup event listener
      return () => window.removeEventListener("resize", getSvgContainerSize);
    }, [width]);
  

    //width-530.........height-260
  
  // Create a treemap layout
  const treemap = d3.treemap().size([width, height]);
  // Generate the treemap layout
  treemap(root);

  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    return context.measureText(text).width;
  }
  function getTextHeight(font) {
    const span = document.createElement("span");
    span.textContent = "M"; // A single character to measure the height
    span.style.font = font;
    document.body.appendChild(span);
    const height = span.offsetHeight;
    document.body.removeChild(span);
    return height;
  }

  const svg = d3.select(svgContainer.current);
  const nodes = root.descendants().map((node, i) => {
    const rectWidth = node.x1 - node.x0;
    const rectHeight = node.y1 - node.y0;
    const textContent = node.data.name;
  
    let fontSize = 12; // Initial font size
    let textWidth = 0;
    let textHeight = 0;
    // Added loop to adjust font size for text that fits within the rectangle
    do {
      fontSize -= 1; // Reduce font size in each iteration
      textWidth = getTextWidth(textContent, fontSize + "px"); // Helper function to get text width
      textHeight = getTextHeight(fontSize + "px");
    } while ((textWidth > rectWidth - 2 || textHeight > rectHeight - 2) && fontSize > 8); // Add some padding (2 pixels) and set a minimum font size

    const isTextVisible = rectWidth > (0.06*width) && rectWidth>textWidth && rectHeight>textHeight;
  
    return (
      <g key={i}
      onClick={(e, activeEls) => {
        setSelectedNode({node:node,index:i});
        e.stopPropagation();
        props.clickFilter(e, activeEls, node);
      }}
      onMouseOver={(event) => {
        tooltipRef.current.innerHTML = `<strong style='display:flex;align-items: center; margin-bottom:6px'><div style='background-color:${colors[(i % colors.length) - 1]}; border: 1.5px solid white;margin-right: 5px; height:10px;width:10px'></div>   ${
          node.data.name
        }</strong><span>${props.graphConfig.tooltipMessage} : ${node.data.value}</span>`;
        tooltipRef.current.style.visibility = "visible";
      }}
      onMouseMove={(event) => {
        tooltipRef.current.style.top = `${event.pageY - 10}px`;
        tooltipRef.current.style.left = `${event.pageX + 10}px`;
      }}
      onMouseOut={() => {
        tooltipRef.current.style.visibility = "hidden";
      }}>
       <rect
        key={i}
        x={node.x0}
        y={node.y0}
        width={rectWidth}
        height={rectHeight}
        fill={colors[(i % colors.length) - 1]}
        stroke="white" // Add a stroke attribute for the border
        strokeWidth="0.5" // Specify the width of the border
        cursor="pointer"
      ></rect>
          {(isTextVisible && <text
            x={node.x0 + rectWidth / 2} // Center the text horizontally within the rectangle
            y={node.y0 + rectHeight / 2 }  // (textHeight / 2)   // Center the text vertically within the rectangle
            dominantBaseline="middle"
            textAnchor="middle"
            fill="white"
            cursor="pointer"
            fontSize={fontSize + "px"} // Set the adjusted font size
            fontWeight="bold"
          >
            {textContent}
          </text>)}
      </g>
    );

  });

  svg.selectAll('g')
      .data(nodes)
      .attr('fill','white')
      .transition()
      .duration(1000) // Duration of the animation
      .attr('opacity', 1);
  



  // Render the component
  return (
    <div className=' align-item-center mt-1 tree-chart'>
    <div ref={svgContainer} className="col-md-12">
      <svg width={width} height={height} >
        <g>{nodes}</g>
        {selectedNode && (
        <>
          <rect
            x={0}
            y={0}
            width={width}
            height={height}
            cursor="pointer"
            fill={colors[(selectedNode.index % colors.length) - 1]}
          />
          <text
            x={width / 2} 
            y={height / 2} 
            dominantBaseline="middle"
            textAnchor="middle"
            fill="white"
            cursor="pointer"
            fontSize="15px" 
            
          >
            <tspan x={width / 2} dy="-0.5em" fontWeight="bold">
              {selectedNode.node.data.name}
            </tspan>
            <tspan x={width / 2} dy="1.5em">
              {props.graphConfig.tooltipMessage}&nbsp;:&nbsp;{selectedNode.node.data.value}
            </tspan>
          </text>

          <text
            x={10} 
            y={20} 
            fill="white"
            cursor="pointer"
            fontSize="20px"
            onClick={(e) => {
              setSelectedNode(null); 
              dispatch(
                setListingData({ fields: [], template: props.dataListTemplate })
              );
              props.setReset(false);
              e.stopPropagation();
            }}
          >
            {"\u2190"}
          </text>
        </>
      )}
      </svg>
      <div
        ref={tooltipRef}
        style={{
          position: "absolute",
          zIndex: 10,
          visibility: "hidden",
          background: "#000000",
          color: "#fff",
          padding: "6px",
          borderRadius: "4px",
          opacity: 0.8,
          fontSize:"12px",
          lineHeight:1.2
        }}
      ></div>
    </div>
    </div>
  );
};
